import { createContext, useState, useContext, useEffect } from 'react'
import keycloak from '../keycloak';

interface KeycloakContextInterface {
  initialized: boolean;
  keycloak: typeof keycloak;
}

const KeycloakContext = createContext<KeycloakContextInterface>({} as KeycloakContextInterface);

export const KeycloakProvider = ({ children }: React.PropsWithChildren) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    keycloak
      .init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        // pkceMethod: 'S256',
      })
      .then(() => setInitialized(true))
      .catch(err => {
        console.error("An error occurred during Keycloak initialization", err);
      })
  }, []);

  return (
    <KeycloakContext.Provider value={{ initialized, keycloak }}>
      {children}
    </KeycloakContext.Provider>
  )
}

export const useKeycloak = () => useContext(KeycloakContext);